<template>
  <div id="sectionVenue">
    <ots-main-title></ots-main-title>
    <div class="venueMain">
      <el-form ref="form" :model="form" :rules="rules" label-width="200px">
        <!-- 没配置 麦克风 不展示 -->
        <!--  v-if="form.needMicrophone" -->
        <div class="item">
          <h1>音视频、录音题设置</h1>
          <el-form-item label="视音频播放次数限制：">
            <el-switch v-model="form.videoPlayFlag" :active-value="1" :inactive-value="0" class="mr8" active-text="限制" inactive-text="不限制"></el-switch>
            <el-form-item style="display: inline-block;" prop="videoPlayTimes" v-if="form.videoPlayFlag">
              <el-input v-model.number="form.videoPlayTimes"></el-input>
              <span class="ml8">次</span>
            </el-form-item>
          </el-form-item>
          <!--  prop="isCanRepeatedRecording" -->
          <el-form-item label="录音题作答次数限制：">
            <el-switch v-model="form.isCanRepeatedRecording" :active-value="1" :inactive-value="0" active-text="限制" inactive-text="不限制"></el-switch>
            <p style="display: inline-block;" v-if="form.isCanRepeatedRecording">
              <span class="ml8 mr8 noUser">作答时允许录音一次</span>
            </p>
          </el-form-item>
        </div>

        <div class="item">
          <h1>活动安排</h1>
          <el-form-item label="客户端最早登录时间：" v-if="false">
            <el-switch v-model="form.isOpenEarliestLogin" :active-value="1" :inactive-value="0"></el-switch>
            <p style="display: inline-block;" v-if="form.isOpenEarliestLogin">
              <span class="ml8 mr8 noUser">开考前</span>
              <el-form-item style="display: inline-block;" prop="earliestLoginTime">
                <el-input v-model.number="form.earliestLoginTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">分钟，允许登录客户端</span>
            </p>
          </el-form-item>
          <el-form-item label="最晚进入答卷时间：">
            <el-switch v-model="form.isOpenLatestAnswerTime" :active-value="1" :inactive-value="0"></el-switch>
            <p style="display: inline-block;" v-if="form.isOpenLatestAnswerTime">
              <span class="ml8 mr8 noUser">开考</span>
              <el-form-item style="display: inline-block;" prop="latestAnswerTime">
                <el-input v-model.number="form.latestAnswerTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">分钟后，不允许进入</span>
            </p>
          </el-form-item>
          <el-form-item label="最短答题时长：">
            <el-switch v-model="form.isOpenMinAnswerDuration" :active-value="1" :inactive-value="0"></el-switch>
            <p style="display: inline-block;" v-if="form.isOpenMinAnswerDuration">
              <span class="ml8 mr8 noUser">开始答卷</span>
              <el-form-item style="display: inline-block;" prop="minAnswerDuration">
                <el-input v-model.number="form.minAnswerDuration"></el-input>
              </el-form-item>
              <span class="ml8 noUser">分钟后，才能交卷</span>
            </p>
          </el-form-item>
        </div>
        <!-- v-if="form.examType == 3 && [1, 2].includes(form.faceRecognitionType)" -->
        <div class="item" v-if="form.examType == 3">
          <h1>防作弊设置</h1>
            <el-form-item prop="faceRecognitionType">
              <template #label>
                <span>
                  <el-tooltip class="item" effect="dark" content="考生进入考试、提交试卷的验证方式" placement="bottom">
                    <i class="el-icon-warning" style="color: #606266;"></i>
                  </el-tooltip>
                  考前身份识别类型：
                </span>
              </template>
              <el-radio-group v-model="form.faceRecognitionType">
                <el-radio :label="1">人脸识别</el-radio>
                <el-radio :label="2">活体检测</el-radio>
                <el-radio :label="3">无需人脸识别</el-radio>
              </el-radio-group>
            </el-form-item>

            <div v-if="[1, 2].includes(form.faceRecognitionType)">
              <el-form-item label="允许身份验证：">
                <el-form-item style="display: inline-block;" prop="faceRecognitionCount">
                  <el-input v-model.number="form.faceRecognitionCount"></el-input>
                </el-form-item>
                <span class="ml8">次，学生身份验证不通过</span>
                <el-form-item style="display: inline-block;" prop="isAllowExamByFaceRecognitionNoPass">
                  <el-select v-model="form.isAllowExamByFaceRecognitionNoPass" placeholder="请选择" class="ml8">
                    <el-option label="允许" :value="1"></el-option>
                    <el-option label="不允许" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <span class="ml8">答卷。</span>
              </el-form-item>

              <el-form-item label="开启考中抓拍：">
                <el-switch v-model="form.takePhotoInTest" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
              </el-form-item>
              <el-form-item label="整个过程抓拍：" prop="autoPhotoTimes" v-if="form.takePhotoInTest == 1">
                <el-input v-model.number="form.autoPhotoTimes"></el-input>
                <span class="ml16">次（录入整数）</span>
              </el-form-item>
              <el-form-item label="最短答题时长抓拍：" prop="minAnswerDurationPhotoTimes" v-if="form.isOpenMinAnswerDuration && form.takePhotoInTest">
                <el-input v-model.number="form.minAnswerDurationPhotoTimes"></el-input>
                <span class="ml16">次（录入整数）</span>
              </el-form-item>
              <el-form-item label="开启抓拍强制交卷：" v-if="form.takePhotoInTest">
                <el-switch v-model="form.isForceSubmitByAutoPhoto" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
              </el-form-item>
              <el-form-item label="抓拍几次不通过强制交卷：" prop="failedNTimesGoSubmit" v-if="form.isForceSubmitByAutoPhoto && form.takePhotoInTest">
                <el-input v-model.number="form.failedNTimesGoSubmit"></el-input>
                <span class="ml16">次（录入整数，不能超过设置的考中抓拍次数）</span>
              </el-form-item>
            </div>
        </div>

        <div class="item">
          <h1>考试须知设置</h1>
          <el-form-item label="显示考试须知：">
            <el-switch v-model="form.isShowNotice" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
          <el-form-item label="考试须知标题：" v-if="form.isShowNotice" prop="noticeTitle">
            <el-input v-model="form.noticeTitle" placeholder="请输入考试须知标题"></el-input>
          </el-form-item>
          <el-form-item label="考试须知内容：" v-if="form.isShowNotice">
            <!-- <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入考试须知"
              v-model="form.noticeContent">
            </el-input> -->
            <ots-editor class="editor" v-model="form.noticeContent" />
          </el-form-item>

          <el-form-item label="考试须知是否开启倒计时：" v-if="form.isShowNotice">
            <el-switch v-model="form.isShowNoticeCountdown" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
            <p style="display: inline-block;" v-if="form.isShowNoticeCountdown == 1">
              <span class="ml8 mr8 noUser">，倒计时</span>
              <el-form-item style="display: inline-block;" prop="noticeCountdownTime">
                <el-input v-model.number="form.noticeCountdownTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">秒</span>
            </p>
          </el-form-item>

          <el-form-item label="考试须知按钮名称：" prop="noticeBtnText" v-if="form.isShowNotice">
            <el-input v-model="form.noticeBtnText" placeholder="请输入"></el-input>
          </el-form-item>
        </div>

        <div class="item">
          <h1>考试承诺书设置</h1>
          <el-form-item label="显示考试承诺书：">
            <el-switch v-model="form.isShowCommitment" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
          <el-form-item label="考试承诺书标题：" prop="commitmentTitle"  v-if="form.isShowCommitment">
            <el-input v-model="form.commitmentTitle" placeholder="请输入考试承诺书标题"></el-input>
          </el-form-item>
          <el-form-item label="考试承诺书内容："  v-if="form.isShowCommitment">
            <!-- <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入考试承诺书内容"
              v-model="form.commitment">
            </el-input> -->
            <ots-editor class="editor" v-model="form.commitment" />
          </el-form-item>
          <el-form-item label="考试承诺书倒计时：" v-if="form.isShowCommitment">
            <el-switch v-model="form.isShowCommitmentCountdown" :active-value="1" :inactive-value="0"  active-text="开启" inactive-text="关闭"></el-switch>
            <p style="display: inline-block;" v-if="form.isShowCommitmentCountdown == 1">
              <span class="ml8 mr8 noUser">，倒计时</span>
              <el-form-item prop="commitmentCountdownTime" style="display: inline-block;">
                <el-input v-model.number="form.commitmentCountdownTime"></el-input>
              </el-form-item>
              <span class="ml8 noUser">秒</span>
            </p>
          </el-form-item>
        </div>

        <div class="item">
          <h1>考试结束</h1>
          <el-form-item label="交卷结束语：" prop="peroration">
            <el-input v-model="form.peroration" placeholder="请输入交卷结束语"></el-input>
          </el-form-item>
        </div>
      </el-form>

    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  getSessionConfigAPI,
  saveSessionConfigAPI
} from "@/http/modules/examSet/section";
export default {
  name: "sectionVenue",
  data() {
    return {
      saveMethods: "addOrEdit",
      backMethods: "goBack",
      sessionId: this.$route.query.id,
      planId: this.$route.query.planId,
      form: {
        // 视频播放次数
        "videoPlayTimes": null,
        // 录音题是否可以重复录制
        "isCanRepeatedRecording": null,
        // 是否开启客户端最早登录时间
        "isOpenEarliestLogin": null,
        // 客户端最早登录时间
        "earliestLoginTime": null,
        // 是否开启最晚进入答卷时间
        "isOpenLatestAnswerTime": null,
        // 最晚进入答卷时间
        "latestAnswerTime": null,
        // 是否开启最短答题时长
        "isOpenMinAnswerDuration": null,
        // 最短答题时长
        "minAnswerDuration": null,
        // 考前身份识别类型
        "faceRecognitionType": null,
        // 允许身份验证
        "faceRecognitionCount": null,
        // 身份验证不通过，是否允许答卷
        "isAllowExamByFaceRecognitionNoPass": null,
        // 开启考中抓拍
        "takePhotoInTest": null,
        // 考中抓拍次数 
        "autoPhotoTimes": null,
        // 最短答题时长抓拍
        "minAnswerDurationPhotoTimes": null,
        // 抓拍强制交卷
        "isForceSubmitByAutoPhoto": null,
        // 抓拍几次不通过强制交卷
        "failedNTimesGoSubmit": null,
        // 显示考试须知
        "isShowNotice": null,
        // 考试须知标题
        "noticeTitle": null,
        // 考试须知内容
        "noticeContent": null,
        // 考试须知是否开启倒计时
        "isShowNoticeCountdown": null,
        // 考试须知倒计时（s）
        "noticeCountdownTime": null,
        // 考试须知按钮名称
        "noticeBtnText": null,
        // 显示考试承诺书
        "isShowCommitment": null,
        // 考试承诺书标题
        "commitmentTitle": null,
        // 考试承诺书内容
        "commitment": null,
        // 考试承诺书倒计时
        "isShowCommitmentCountdown": null,
        // 考试承诺书倒计时（s）
        "commitmentCountdownTime": null,
        // 交卷结束语
        "peroration": "试卷提交成功",
        // 是否需要麦克风
        "needMicrophone": null,
        // 人脸识别签到
        "isSignState": null,
        // 考试时间
        "examTime": null,
        // 考试方式
        "examType": null
      },
      rules: {
        peroration: [
          { required: true, message: '请输入交卷结束语', trigger: 'blur' }
        ],
        commitmentTitle: [
          { required: true, message: '请输入考试承诺书标题', trigger: 'blur' }
        ],
        noticeBtnText: [
          { required: true, message: '请输入考试须知按钮名称', trigger: 'blur' }
        ],
        noticeTitle: [
          { required: true, message: '请输入考试须知标题', trigger: 'blur' }
        ],
        isAllowExamByFaceRecognitionNoPass: [
          { required: true, message: '请选择是否允许答卷', trigger: 'change' }
        ],
        faceRecognitionType: [
          { required: true, message: '请选择考前身份识别类型', trigger: 'change' }
        ],
        isCanRepeatedRecording: [
          { required: true, message: '请选择录音题是否可以重复录制', trigger: 'change' }
        ],
        videoPlayTimes: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        earliestLoginTime: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        latestAnswerTime: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        minAnswerDuration: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        faceRecognitionCount: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        autoPhotoTimes: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        failedNTimesGoSubmit: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        minAnswerDurationPhotoTimes: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        noticeCountdownTime: [
          {validator: this.IntCheck, trigger: 'blur'}
        ],
        commitmentCountdownTime: [
          {validator: this.IntCheck, trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
    "form.noticeTitle": function(val) {
      if (!val) {
        this.form.noticeTitle = "考试须知"
      }
    },
    "form.commitmentTitle": function(val) {
      if (!val) {
        this.form.commitmentTitle = "考试承诺书"
      }
    },
    "form.peroration": function(val) {
      if (!val) {
        this.form.peroration = "试卷提交成功"
      }
    },
    "form.faceRecognitionType": function(val) {
      if (val == 3) {
        this.form.autoPhotoTimes = null;
        this.form.minAnswerDurationPhotoTimes = null;
        this.form.takePhotoInTest = 0;
        this.form.failedNTimesGoSubmit = 0;
        this.form.isForceSubmitByAutoPhoto = 0;
      }
    },
    "form.takePhotoInTest": function (val) {
      if (!val) {
        this.form.minAnswerDurationPhotoTimes = null;
        this.form.failedNTimesGoSubmit = 0;
      }
    },
    "form.isOpenMinAnswerDuration": function (val) {
      if (!val) {
        this.form.minAnswerDurationPhotoTimes = null;
      }
    },
    "form.isForceSubmitByAutoPhoto": function (val) {
      if (!val) {
        this.form.failedNTimesGoSubmit = 0;
      }
    },
    "form.videoPlayFlag": function (val) {
      if (!val) {
        this.form.videoPlayTimes = null;
      }
    },
  },
  mounted() {
    this.getConfig();
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),
    async getConfig() {
      const { code, data } = await getSessionConfigAPI({sessionId: this.sessionId});
      if (code === 1) {
        this.form = { ...data };
        this.form.noticeTitle = this.form.noticeTitle ? this.form.noticeTitle:  "考试须知";
        this.form.commitmentTitle = this.form.commitmentTitle ? this.form.commitmentTitle: "考试承诺书";
        this.form.peroration = this.form.peroration ? this.form.peroration: "试卷提交成功";
      }
    },
    IntCheck(rule, value, callback) {  
      // if (value || value == 0) {
        let reg = /^[1-9]\d*$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正整数！'));
        } else {
          callback();
        }
      // } 
      callback();
    },
    async addOrEdit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          // 考试须知承诺书
          if (this.form.isShowNotice && !this.form.noticeContent) {
            this.$message.error("请输入考试须知内容！");
            return;
          }
          if (this.form.isShowCommitment && !this.form.commitment) {
            this.$message.error("请输入考试承诺书内容！")
            return;
          }
          // 防作弊设置
          if ([1, 2].includes(this.form.faceRecognitionType) && this.form.takePhotoInTest) {
            if (this.form.isOpenMinAnswerDuration && (this.form.minAnswerDurationPhotoTimes > this.form.autoPhotoTimes)) {
              this.$message.error("最短答题时长抓拍次数不能大于整个过程抓拍次数！");
              return;
            }
            if (this.form.isForceSubmitByAutoPhoto && (this.form.failedNTimesGoSubmit > this.form.autoPhotoTimes)) {
              this.$message.error("抓拍几次不通过强制交卷次数不能大于整个过程抓拍次数！");
              return;
            }
          }
          let params = { ...this.form, planId: this.planId }
          const { code } = await saveSessionConfigAPI(params)
          if  (code == 1) {
            this.$message.success("场次配置成功！");
            this.goBack();
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$router.push({
        path: "/sectionList/section",
        query: {
          id: this.planId,
        },
      });
    }
  }
}
</script>

<style lang="less" scoped>
.noUser{ 
  user-select: none;
}
h1 {
  color: #2d2f33;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 40px;
}
/deep/ .el-form-item__content {
  .el-radio-group {
    padding-top: 8px;
    box-sizing: border-box;
    margin: auto;
  }
}
.venueMain {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px !important;
}
</style>